import "./homePageRrc.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { hasAnyPermission } from "../../permissions";
const ROLES = {
  SUPER_ADMIN: "SUPER ADMIN",
  ADMIN: "ADMIN",
  OTA_MANAGER: "OTA MANAGER",
  OTA_EXECUTIVE: "OTA EXECUTIVE",
  SALES_EXECUTIVE: "SALES EXECUTIVE",
  ONBOARDING_MANAGER: "ONBOARDING MANAGER",
  ONBOARDING_EXECUTIVE: "ONBOARDING EXECUTIVE",
};
function HomePageRrc() {
  const navigate = useNavigate();
  // BACK BUTTON STARTS HERE
    const handleBackToHome = () => {
    navigate("/HomePage");
  };
  const loggedInRole = localStorage.getItem("loggedInRole");
  const canSeeRevenueCalculator =
    [
      ROLES.SUPER_ADMIN,
      ROLES.ADMIN,
      ROLES.OTA_MANAGER,
    ].includes(loggedInRole) || hasAnyPermission(["show_rrc_revenue_calculator"]);
  const canSeePropertyWiseTargets =
    [
      ROLES.SUPER_ADMIN,
      ROLES.ADMIN,
      ROLES.OTA_MANAGER,
      ROLES.OTA_EXECUTIVE,
      ROLES.SALES_EXECUTIVE,
    ].includes(loggedInRole) || hasAnyPermission(["show_rrc_property_wise_targets"]);
  useEffect(() => {
    if (!localStorage.getItem("isAuthenticated")) {
      navigate("/admin");
      return;
    }
    if (!canSeeRevenueCalculator && !canSeePropertyWiseTargets) {
      alert("Access denied.");
      navigate("/HomePage");
    }
  }, [canSeeRevenueCalculator, canSeePropertyWiseTargets, navigate]);
  return (
  <main className="rrc-home-container">
    <button
      type="button"
      className="rrc-back-btn"
      onClick={handleBackToHome}
    >
      ← Back
    </button>
    <header className="rrc-home-header">
        <h1 className="rrc-home-title">Room Rate Calculator</h1>
        <p className="rrc-home-subtitle">
          Forecast your property's revenue potential using seasonal trends and targets.
        </p>
      </header>
      <section className="rrc-home-grid">
        {canSeeRevenueCalculator && (
          <article className="rrc-home-card calculator-container">
            <h4 className="rrc-home-card-title">Revenue Calculator</h4>
            <p className="rrc-home-card-text">
              Forecast revenue based on trends.
            </p>
            <button
              className="rrc-home-btn"
              type="button"
              onClick={() => navigate("/rfc")}
            >
              OPEN CALCULATOR
            </button>
          </article>
        )}
        {canSeePropertyWiseTargets && (
          <article className="rrc-home-card propertylist-container">
            <h4 className="rrc-home-card-title">Property Wise Targets</h4>
            <p className="rrc-home-card-text">
              Check your filled property targets.
            </p>
            <button
              className="rrc-home-btn"
              type="button"
              onClick={() => navigate("/propertyrevenue")}
            >
              VIEW TARGETS
            </button>
          </article>
        )}
      </section>
      <footer>
        © 2026 RevX Hospitality. All Rights Reserved. Developed by RevX Hospitality.
      </footer>
    </main>
  );
}
export default HomePageRrc;
